import { Component, Inject, OnInit } from '@angular/core';
import { InternalEquipmentPerformancesDate } from '../../../../model/internalEquipmentPerformances';
import { CustomDatepickerHeaderComponent } from '../../../shared/datepicker-custom-header/datepicker-custom-header.component';
import * as _ from 'lodash';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ThemeService } from '../../../../services/theme.service';
import { SnackBarService } from '../../../../services/snackBar.service';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';

export interface DialogDataInternalEquipmentEditDatePerformances {
  frecuencyCalibration: number;
  frecuencyVerification: number;
  isCalibrationNotDate: boolean;
  isCharaterizationNotDate: boolean;
  isVerificationNotDate: boolean;
  isMaintenanceNotDate: boolean;
  isQualificationNotDate: boolean;
  hasCertificate: boolean;
  processDate: Date;
}

@Component({
  selector: 'app-internal-equipment-edit-date-performances',
  templateUrl: './internal-equipment-edit-date-performances.component.html',
  styleUrls: ['./internal-equipment-edit-date-performances.component.scss'],
  standalone: false
})
export class InternalEquipmentEditDatePerformancesComponent implements OnInit {

  dataDate: InternalEquipmentPerformancesDate = new InternalEquipmentPerformancesDate();

  customDatepickerHeader = CustomDatepickerHeaderComponent;
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogDataInternalEquipmentEditDatePerformances,
  public dialogRef: MatDialogRef<InternalEquipmentEditDatePerformancesComponent>,
  public dialog: MatDialog,
  private themeService: ThemeService,
  public snackBarService: SnackBarService,
  private translate: TranslateService) { }

  ngOnInit(): void {
    if (this.data.hasCertificate && this.data.isCalibrationNotDate) {
      this.dataDate.processDateCalibration = this.data.processDate;
    } else if (this.data.hasCertificate && this.data.isVerificationNotDate) {
      this.dataDate.processDateVerification = this.data.processDate;
    } else if (this.data.hasCertificate && this.data.isMaintenanceNotDate) {
      this.dataDate.processDateMaintenance = this.data.processDate;
    } else if (this.data.hasCertificate && this.data.isCharaterizationNotDate) {
      this.dataDate.processDateCharaterization = this.data.processDate;
    } else if (this.data.hasCertificate && this.data.isQualificationNotDate) {
      this.dataDate.processDateQualification = this.data.processDate;
    } else {
      this.data.hasCertificate = false;
    }
  }

  saveDate(field: string, event: any): void {
    let value: Date | string = event.value;
    if (value != null) {
      if (value instanceof Date) {
        value = DateTime.fromJSDate(value).toFormat('dd/MM/yyyy');
      }

      let date = DateTime.fromFormat(value + ' 12:00:00 +00:00', 'dd/MM/yyyy HH:mm:ss Z');
      
      while (date.year < 1970) {
        date = date.plus({ years: 100 });
      }

      if (field === 'processDateCalibration') {
        this.dataDate.processDateCalibration = date?.toJSDate();

        let frequency: number;
      // eslint-disable-next-line max-len
        this.dataDate.expirationDateCalibration = _.cloneDeep(this.dataDate.processDateCalibration);
        if (this.data?.frecuencyCalibration) {
          frequency = this.data.frecuencyCalibration;
        } else {
          frequency = 12;
        }
        this.dataDate.expirationDateCalibration.setMonth(this.dataDate.expirationDateCalibration.getMonth() + Number(frequency));
      }

      if (field === 'expirationDateCalibration') {
        this.dataDate.expirationDateCalibration = date?.toJSDate();
        console.log(this.dataDate.expirationDateCalibration);
      }
    }

  }

  saveDateQualification(field: string, event: any): void {
    let value: Date | string = event.value;
    if (value != null) {
      if (value instanceof Date) {
        value = DateTime.fromJSDate(value).toFormat('dd/MM/yyyy');
      }

      let date = DateTime.fromFormat(value + ' 12:00:00 +00:00', 'dd/MM/yyyy HH:mm:ss Z');
      
      while (date.year < 1970) {
        date = date.plus({ years: 100 });
      }

      if (field === 'processDateQualification') {
        this.dataDate.processDateQualification = date?.toJSDate();
      // eslint-disable-next-line max-len
        this.dataDate.expirationDateQualification = _.cloneDeep(this.dataDate.processDateQualification);
        this.dataDate.expirationDateQualification.setMonth(this.dataDate.expirationDateQualification.getMonth() + 12);
      }

      if (field === 'expirationDateQualification') {
        this.dataDate.expirationDateQualification = date?.toJSDate();
      }
    }
  }

  saveDateMaintenance(field: string, event: any): void {
    let value: Date | string = event.value;
    if (value != null) {

     if (value instanceof Date) {
        value = DateTime.fromJSDate(value).toFormat('dd/MM/yyyy');
      }

      let date = DateTime.fromFormat(value + ' 12:00:00 +00:00', 'dd/MM/yyyy HH:mm:ss Z');
      
      while (date.year < 1970) {
        date = date.plus({ years: 100 });
      }

      if (field === 'processDateMaintenance') {
        this.dataDate.processDateMaintenance = date?.toJSDate();
      // eslint-disable-next-line max-len
        this.dataDate.expirationDateMaintenance = _.cloneDeep(this.dataDate.processDateMaintenance);
        this.dataDate.expirationDateMaintenance.setMonth(this.dataDate.expirationDateMaintenance.getMonth() + 12);
      }

      if (field === 'expirationDateMaintenance') {
        this.dataDate.expirationDateMaintenance = date?.toJSDate();
      }
    }
  }

  saveDateVerification(field: string, event: any): void {
    let value: Date | string = event.value;
    if (value != null) {

     if (value instanceof Date) {
        value = DateTime.fromJSDate(value).toFormat('dd/MM/yyyy');
      }

      let date = DateTime.fromFormat(value + ' 12:00:00 +00:00', 'dd/MM/yyyy HH:mm:ss Z');

      while (date.year < 1970) {
        date = date.plus({ years: 100 });
      }

      if (field === 'processDateVerification') {
        this.dataDate.processDateVerification = date?.toJSDate();

        let frequency: number;
      // eslint-disable-next-line max-len
        this.dataDate.expirationVerification = _.cloneDeep(this.dataDate.processDateVerification);
        if (this.data?.frecuencyVerification) {
          frequency = this.data.frecuencyVerification;
        } else {
          frequency = 12;
        }
        this.dataDate.expirationVerification.setMonth(this.dataDate.expirationVerification.getMonth() + Number(frequency));
      }

      if (field === 'expirationVerification') {
        this.dataDate.expirationVerification = date?.toJSDate();;
      }
    }
  }

  saveDateCharacterization(field: string, event: any): void {
    let value: Date | string = event.value;
    if (value != null) {
      if (value instanceof Date) {
        value = DateTime.fromJSDate(value).toFormat('dd/MM/yyyy');
      }

      let date = DateTime.fromFormat(value + ' 12:00:00 +00:00', 'dd/MM/yyyy HH:mm:ss Z');

      while (date.year < 1970) {
        date = date.plus({ years: 100 });
      }

      if (field === 'processDateCharaterization') {
        this.dataDate.processDateCharaterization = date?.toJSDate();
      // eslint-disable-next-line max-len
        this.dataDate.expirationCharaterization = _.cloneDeep(this.dataDate.processDateCharaterization);
        this.dataDate.expirationCharaterization.setMonth(this.dataDate.expirationCharaterization.getMonth() + 12);
      }

      if (field === 'expirationCharaterization') {
        this.dataDate.expirationCharaterization = date?.toJSDate();
      }
    }
  }

  onOkClick(): void {
    const errores: string[] = [];
    if (this.data.isCalibrationNotDate) {
      if (!this.dataDate.processDateCalibration) {
        errores.push(this.translate.instant('internalEquipment.date.performance.calibrateDate.error') as string);
       } else if (!this.dataDate.expirationDateCalibration) {
        errores.push(this.translate.instant('internalEquipment.date.performance.nextCalibrateDate.error') as string);
       }
    }

    if (this.data.isMaintenanceNotDate) {
      if (!this.dataDate.processDateMaintenance) {
        errores.push(this.translate.instant('internalEquipment.date.performance.maintenanceDate.error') as string);
      } else if (!this.dataDate.expirationDateMaintenance) {
        errores.push(this.translate.instant('internalEquipment.date.performance.nextMaintenanceDate.error') as string);
      }
    }

    if (this.data.isCharaterizationNotDate) {
      if (!this.dataDate.processDateCharaterization) {
        errores.push(this.translate.instant('internalEquipment.date.performance.characterizationDate.error') as string);
      } else if (!this.dataDate.expirationCharaterization) {
        errores.push(this.translate.instant('internalEquipment.date.performance.nextCharacterizationDate.error') as string);
      }
    }

    if (this.data.isQualificationNotDate) {
      if (!this.dataDate.processDateQualification) {
        errores.push(this.translate.instant('internalEquipment.date.performance.qualificationDate.error') as string);
       } else if (!this.dataDate.expirationDateQualification) {
        errores.push(this.translate.instant('internalEquipment.date.performance.nextQualificationDate.error') as string);
       }
    }

    if (this.data.isVerificationNotDate) {
      if (!this.dataDate.processDateVerification) {
        errores.push(this.translate.instant('internalEquipment.date.performance.verificationDate.error') as string);
       } else if (!this.dataDate.expirationVerification) {
        errores.push(this.translate.instant('internalEquipment.date.performance.nextVerificationDate.error') as string);
       }
    }

    if (errores && errores.length > 0) {
      this.snackBarService.sendError(errores.join('\n'));
    } else {
      this.dataDate.hasCalibrates = this.data.hasCertificate;
      this.dialogRef.close(this.dataDate);
   }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getTheme(): string {
    return this.themeService.getTheme();
  }

}
